export default {
  getBillOrderInfo: {
    url: '/index/info/getBillOrderInfo',
    method: 'get',
  },
  getFinanceOrderInfo: {
    url: '/index/info/getFinanceOrderInfo',
    method: 'get',
  }
};